export const clampValue = (value, min, max) =>
  Math.min(Math.max(value, min), max);

export const getFitZoom = ({
  viewportWidth,
  viewportHeight,
  artboardWidth,
  artboardHeight,
  padding = 80,
  minZoom = 0.25,
  maxZoom = 2,
}) => {
  if (!viewportWidth || !viewportHeight || !artboardWidth || !artboardHeight) {
    return 1;
  }

  const safeWidth = Math.max(0, viewportWidth - padding);
  const safeHeight = Math.max(0, viewportHeight - padding);
  const scale = Math.min(safeWidth / artboardWidth, safeHeight / artboardHeight);
  if (!Number.isFinite(scale) || scale <= 0) return 1;
  return clampValue(scale, minZoom, maxZoom);
};

export const getCenteredPan = ({
  viewportWidth,
  viewportHeight,
  artboardWidth,
  artboardHeight,
  zoom,
}) => {
  if (!viewportWidth || !viewportHeight) {
    return { x: 0, y: 0 };
  }
  const centeredX = (viewportWidth - artboardWidth * zoom) / 2;
  const centeredY = (viewportHeight - artboardHeight * zoom) / 2;
  return {
    x: Number.isFinite(centeredX) ? centeredX : 0,
    y: Number.isFinite(centeredY) ? centeredY : 0,
  };
};
